import React from 'react';
import { getTranslateByScope } from '../../i18n';
import './CustomerList.scss';
import { SpacingBox } from '../../Components';
import ContactEntryHeader from './ContactEntryHeader';
import useContactList from './useContactList';
import ContactEntryRow from './ContactEntryRow/ContactEntryRow';
const translate = getTranslateByScope('customerList');

export const CustomerList = (props) => {
  const {
    addContact,
    clickClose,
    clickOpen,
    contacts,
    open,
    syncContact,
    deleteContact,
  } = useContactList(props.customerId);

  return (
    <>
      <SpacingBox>
        {!open && (
          <div className='open' onClick={clickOpen}>
            {translate('open')}
          </div>
        )}
        {open && (
          <>
            <div className='open' onClick={clickClose}>
              {translate('close')}
            </div>
            <h1 className='title'>
              {translate('title')}
              <div className='add-contact btn btn-primary' onClick={addContact}>
                Add Contact
              </div>
            </h1>
            <table className='table'>
              <ContactEntryHeader />
              <tbody>
                {contacts.map((c) => (
                  <ContactEntryRow
                    key={c.Id}
                    contact={c}
                    syncContact={syncContact}
                    deleteContact={deleteContact}
                  />
                ))}
              </tbody>
            </table>
            <p>{translate('desc')}</p>
          </>
        )}
      </SpacingBox>
    </>
  );
};
